import { signal } from '@angular/core';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { AgentUserInputComponent } from 'AgentApp/ts/features/agent/components/agent-user-input/agent-user-input.component';
import { AgentLoaderComponent } from 'AgentApp/ts/features/agent/components/agent-loader/agent-loader.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
function AgentSidePanelComponent_Conditional_89_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-agent-loader", 41);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("currentLoadingText", ctx_r0.currentLoadingText())("agentSteps", ctx_r0.currentTaskSteps());
} }
const TEST_AGENT_STEPS = [
    {
        title: 'Tool call 1',
        description: 'Description of tool call 1',
    },
    {
        title: 'Tool call 2',
        description: 'Description of tool call 2',
    },
    {
        title: 'Tool call 3',
        description: 'Description of tool call 3',
    },
];
const DEFAULT_LOADING_TEXT = 'Understanding your request...';
export class AgentSidePanelComponent {
    constructor() {
        this.isLoading = signal(true);
        this.currentLoadingText = signal(DEFAULT_LOADING_TEXT);
        this.currentTaskSteps = signal(TEST_AGENT_STEPS);
    }
}
AgentSidePanelComponent.ɵfac = function AgentSidePanelComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentSidePanelComponent)(); };
AgentSidePanelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentSidePanelComponent, selectors: [["ycn-agent-side-panel"]], decls: 101, vars: 1, consts: [[1, "side-panel-tasks-bar"], [1, "dropdown"], [1, "dropdown-toggle", "height-40", "pl-20", "pr-20"], [1, "d-flex", "align-items-center", "mr-2"], [1, "text-thin"], [1, "d-flex", "align-items-center", "ml-1"], [1, "circle-stats-rounded", "ml-1", 2, "--cs-rounded-percentage", "88", "--cs-rounded-size", "26px", "--cs-rounded-stroke-width", "3px"], ["id", "circleGradient8656", "x1", "0%", "y1", "0%", "x2", "100%", "y2", "100%"], ["offset", "0%", "stop-color", "#0273CF"], ["offset", "100%", "stop-color", "#E5F2FC"], ["cx", "13", "cy", "13", "r", "11.5", 1, "progress", 2, "stroke", "url(#circleGradient8656)"], [1, "collapse-chevron", "align-self-center"], [1, "dropdown-menu", "dropdown-menu-fullwidth", "pt-0"], [1, "panel-action", "min-height-base", "pt-0", "pb-0"], ["data-tabs-content", "aiAgentTabs", 1, "nav", "nav-tabs", "justify-content-start"], [1, "nav-item"], ["href", "#", "data-tab-index", "0", 1, "nav-link", "text-normal-case"], ["href", "#", "data-tab-index", "1", 1, "nav-link", "active", "text-normal-case"], ["id", "aiAgentTabs", 1, "tab-content"], [1, "tab-pane", "pl-0", "pr-0"], [1, "table", "table-hover", "mb-0"], [1, "text-default"], [1, "pl-0", "text-right"], [1, "btn", "btn-transparent", "btn-lightgray", "btn-circle", "btn-xs"], ["ycnIcon", "", "name", "icon-close"], [1, "tab-pane", "pl-0", "pr-0", "active"], [1, "max-width-150"], [1, "td-ellipsis", "text-blue"], [1, "td-ellipsis-content"], [1, "text-right"], [1, "d-inline-flex", "width-40", "height-4", "bg-gray-base-90"], [1, "bg-positive-1", 2, "width", "77%"], [1, "text-default", "mr-1"], ["ycnIcon", "", "name", "icon-delete"], [1, "bg-positive-1", 2, "width", "41%"], [1, "disabled"], [1, "td-ellipsis"], ["colspan", "2", 1, "text-right"], [1, "mr-1"], [1, "side-panel-content", "bg-side-panel-ai", "height-full"], [1, "flex-auto", "z-1", "overflow-auto", "min-height-0", "pt-4", "pl-20", "pr-20"], [3, "currentLoadingText", "agentSteps"], [1, "height-full", "d-flex", "flex-column", "justify-content-center", "text-center"], [1, "mb-6"], [1, "side-panel-empty-state", "mb-1"], [1, "side-panel-empty-subtitle"], [1, "side-panel-empty-text", "pt-2"], [1, "text-normal"]], template: function AgentSidePanelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "span", 4);
        i0.ɵɵtext(5, "Tasks");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(8, "svg")(9, "defs")(10, "linearGradient", 7);
        i0.ɵɵelement(11, "stop", 8)(12, "stop", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(13, "circle", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(14, "span");
        i0.ɵɵtext(15, "2");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(16, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 12)(18, "div", 13)(19, "ul", 14)(20, "li", 15)(21, "a", 16);
        i0.ɵɵtext(22, "Complete");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(23, "li", 15)(24, "a", 17);
        i0.ɵɵtext(25, "In Progress");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(26, "div", 18)(27, "div", 19)(28, "table", 20)(29, "tbody")(30, "tr")(31, "td")(32, "div", 21);
        i0.ɵɵtext(33, "Risk/Reward Scatterplot");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "span");
        i0.ɵɵtext(35, "10/09/25, 12:39 PM");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(36, "td", 22)(37, "button", 23);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(38, "svg", 24);
        i0.ɵɵelementEnd()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(39, "tr")(40, "td")(41, "div", 21);
        i0.ɵɵtext(42, "AAPL Growth Metrics Fund Chart");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "span");
        i0.ɵɵtext(44, "10/09/25, 12:39 PM");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(45, "td", 22)(46, "button", 23);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(47, "svg", 24);
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(48, "div", 25)(49, "table", 20)(50, "tbody")(51, "tr")(52, "td", 26)(53, "div", 27)(54, "span", 28);
        i0.ɵɵtext(55, "Building scenario analysis model");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(56, "td", 29)(57, "div", 30);
        i0.ɵɵelement(58, "div", 31);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(59, "td", 22)(60, "span", 32);
        i0.ɵɵtext(61, "77%");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(62, "button", 23);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(63, "svg", 33);
        i0.ɵɵelementEnd()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(64, "tr")(65, "td", 26)(66, "div", 27)(67, "span", 28);
        i0.ɵɵtext(68, "Creating Fund Chart");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(69, "td", 29)(70, "div", 30);
        i0.ɵɵelement(71, "div", 34);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(72, "td", 22)(73, "span", 32);
        i0.ɵɵtext(74, "41%");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(75, "button", 23);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(76, "svg", 33);
        i0.ɵɵelementEnd()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(77, "tr", 35)(78, "td", 26)(79, "div", 36)(80, "span", 28);
        i0.ɵɵtext(81, "Creating Fund Chart");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(82, "td", 37)(83, "span", 38);
        i0.ɵɵtext(84, "Cancelled");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(85, "button", 23);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(86, "svg", 24);
        i0.ɵɵelementEnd()()()()()()()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(87, "div", 39)(88, "div", 40);
        i0.ɵɵtemplate(89, AgentSidePanelComponent_Conditional_89_Template, 1, 2, "ycn-agent-loader", 41);
        i0.ɵɵelementStart(90, "div", 42)(91, "div", 43)(92, "div", 44);
        i0.ɵɵtext(93, "Hello, Clint.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(94, "div", 45);
        i0.ɵɵtext(95, "How can I help you today?");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(96, "div", 46);
        i0.ɵɵtext(97, "Not sure? ");
        i0.ɵɵelementStart(98, "div", 47);
        i0.ɵɵtext(99, "Ask me what I can do.");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(100, "ycn-agent-user-input");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(89);
        i0.ɵɵconditional(ctx.isLoading() ? 89 : -1);
    } }, dependencies: [IconModule, i1.IconDirective, AgentUserInputComponent, AgentLoaderComponent], styles: ["[_nghost-%COMP%] {\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n        }"], changeDetection: 0 });
